 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 
const GetMenuItemsByParent =(params?:any)   =>
request({
  url: ApiURL.Query.GetMenuItemsByParent,
  method: RequestType.GET,
  params:params,
});

const GetMenuList =(params?:any)   =>
request({
  url: ApiURL.Query.GetMenuList,
  method: RequestType.GET,
  params:params,
});
const GetMenuAll=(params?:any)=>request({
  url: ApiURL.Query.GetMenuAll,
  method: RequestType.GET,
  params:params,
});
const GetMenuRoleList=(params:any)=>request({
  url: ApiURL.Query.GetMenuRoleList+"?menuId="+params,
  method: RequestType.GET,
  //params:params,
});
const GetMenuAllEndPoints=()=>request({
  url: ApiURL.Query.GetMenuAllEndPoints,
  method: RequestType.GET,
  //params:params,
});
const GetMenuApplicationList=(params?:any)=>request({
  url: ApiURL.Query.GetMenuApplicationList,
  method: RequestType.GET,
  params:params,
});
const GetMenuApplicationByAppId=(params:any)=>request({
  url: ApiURL.Query.GetMenuApplicationByAppId+params,
  method: RequestType.GET,
  //params:params,
});
//#region Flow
 
const MenuQuery = {
  GetMenuItemsByParent,
  GetMenuList,
  GetMenuAll,
  GetMenuRoleList,
  GetMenuAllEndPoints,
  GetMenuApplicationList,
  GetMenuApplicationByAppId
};

export default MenuQuery;
